const allFormFieldsFilled = formData => {
  return Object.values(formData).every(value => {
    return value !== "" && value !== null && value !== undefined;
  });
};

const isNameValid = (field: string) => new RegExp(/^[^\s].*/).test(field);

const hasBeginningWhiteSpace = (field: string) => new RegExp(/^\s/g).test(field);

const getFieldErrors = (errors: Record<string, string[]>) => {
  for (const field in errors) {
    if (errors[field] && field !== "__typename") {
      return `${field} ${errors[field][0]}`;
    }
  }

  return null;
};

const hasFieldErrors = (errors: Record<string, string[]>) =>
  Object.values(errors).some(error => error);

export { allFormFieldsFilled, getFieldErrors, hasBeginningWhiteSpace, isNameValid, hasFieldErrors };
